import { useEffect } from "react";
import { Form, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { modalFromLayout, selectFilterOption, getOptionArray, getDataArray } from "@/lib/antdElementFunction";
import { getCurrentAcademicYear, yearArray } from "@/lib/dateTime";
import { SemesterType } from './types';

interface Props {
  form: any;
  info: SemesterType;
  handleType: string;
}

function ModalSemester(props: Props) {
  const { form, info, handleType } = props;
  const semesterT: any = getLangList("semester");

  useEffect(() => {
    const { semesterName, year } = info ?? {};

    handleType === 'updateSemester' && form.setFieldsValue({ semesterName, year });
  }, [form, info, handleType]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
      initialValues={{
        year: getCurrentAcademicYear().toString(),
      }}
    >
      <Form.Item name="year" label={semesterT.YEAR} rules={[{ required: true }]}>
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
        >
          {getOptionArray(getDataArray(yearArray, '', ''))}
        </Select>
      </Form.Item>

      <Form.Item label={semesterT.SEMESTER} name="semesterName" rules={[{ required: true }]}>
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
        >
          {getOptionArray([
            { value: 'Semester 1', label: 'Semester 1' },
            { value: 'Semester 2', label: 'Semester 2' },
            { value: 'Summer', label: 'Summer' },
          ])}
        </Select>
      </Form.Item>
    </Form >
  );
}

export default ModalSemester;